import { Breadcrumb } from "@gull";
import React, { Component, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";

import "react-datepicker/dist/react-datepicker.css";
import { Formik } from "formik";
import * as Yup from "yup";

import { creditSettlement } from "app/services/paymentService";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import {
  RenderDateInput,
  RenderSelectInput,
  RenderTextInput,
} from "app/common/renderInput";

import AllMemberAutoComplete from "../Credit Settings/AllMemberAutoComplete";
import usePagePermission from "app/hooks/usePagePermission";

const creditSettingsSchema = Yup.object().shape({
  creditAmount: Yup.number()
    .required("Please enter Amount")
    .min(1, "Amount should be greater than 0"),
  creditSettlementType: Yup.string().required("Please enter Payment Through"),
  creditSettlementDescription: Yup.string().nullable(),
  memberId: Yup.number().required("Please enter introducer Dist"),
});

function CreditBalanceSettlement() {
  const { canAdd, canView, canEdit, canDelete } = usePagePermission();
  // console.log({ canAdd, canView, canEdit, canDelete });

  const [formData, setFormData] = useState({
    creditSettlementDescription: "",
    creditSettlementType: "CREDIT WITHDRAWAL",
    creditAmount: "",
    memberId: "",
  });

  const [paymentTypeList] = useState([
    { value: "CREDIT SETTLEMENT", label: "CREDIT SETTLEMENT" },
  ]);

  const SubmitHandler = async (values, { resetForm }) => {
    const res = await creditSettlement(values);

    res.status === "Error"
      ? NotificationManager.error(res.message)
      : NotificationManager.success(res.message);

    resetForm({ values: "" });
  };

  const handlChangeDate = (date) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      requestDate: moment(date).format("DD-MM-YYYY"),
    }));
  };

  return (
    <div>
      <Helmet>
        <title>Credit Balance Settlement</title>
      </Helmet>
      <Breadcrumb
        routeSegments={[{ name: "Credit Balance Settlement" }]}
      ></Breadcrumb>
      <div>
        <Card>
          <Card.Body>
            <Formik
              initialValues={formData}
              validationSchema={creditSettingsSchema}
              onSubmit={SubmitHandler}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
              }) => (
                <form onSubmit={handleSubmit}>
                  <Row>
                    <Col lg={4}>
                      <div>
                        <label> Member List </label>
                        <span className="text-danger"> * </span>
                        <AllMemberAutoComplete
                          setFieldValue={setFieldValue}
                          memberId={values.memberId}
                          handleChangeOptions={(memberId) => {
                            setFieldValue("memberId", memberId);
                            setFormData((prevFormData) => ({
                              ...prevFormData,
                              memberId,
                            }));
                          }}
                          name="memberId"
                          value={values.memberId}
                          // required
                        />
                        {!values.memberId ? (
                          <small className="text-danger">
                            {errors.memberId}
                          </small>
                        ) : (
                          ""
                        )}
                      </div>
                    </Col>

                    <Col lg={4}>
                      <RenderTextInput
                        type="number"
                        name="creditAmount"
                        display="Credit Amount"
                        placeholder="Credit Amount"
                        value={values.creditAmount}
                        error={errors.creditAmount}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.creditAmount}
                        required
                      ></RenderTextInput>
                    </Col>

                    <Col>
                      <RenderSelectInput
                        name="creditSettlementType"
                        display="Settlement Type"
                        placeholder="Settlement Type"
                        value={values.creditSettlementType}
                        error={errors.creditSettlementType}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.creditSettlementType}
                        items={paymentTypeList}
                        required
                      ></RenderSelectInput>
                    </Col>
                  </Row>

                  <Row>
                    <div>
                      <label htmlFor="creditSettlementDescription">
                        Settlement Description
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        name="creditSettlementDescription"
                        placeholder="Credit Settlement Description"
                        value={values.creditSettlementDescription}
                        error={errors.creditSettlementDescription}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.creditSettlementDescription}
                      ></textarea>
                    </div>
                  </Row>
                  {canAdd && (
                    <Row>
                      <Col className="mt-2 mx-3">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? "Submitting..." : "Submit"}
                        </button>
                      </Col>
                    </Row>
                  )}
                </form>
              )}
            </Formik>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}

export default CreditBalanceSettlement;
